import { render, staticRenderFns } from "./AdvertGroup.vue?vue&type=template&id=6f99dc0b"
import script from "./AdvertGroup.vue?vue&type=script&lang=js"
export * from "./AdvertGroup.vue?vue&type=script&lang=js"
import style0 from "./AdvertGroup.vue?vue&type=style&index=0&id=6f99dc0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports